import { useState } from "react";
import Footer from "./Footer";


export default function Clock() 
{

  let hour = new Date().getMinutes();
  let min = new Date().getMinutes();
  let ndate = new Date().toLocaleDateString();
  let sec = new Date().getSeconds();
  let nhour ;//= new Date().getHours();

  const [chour, setstate] = useState(nhour)
  const [cdate, setdate] = useState(ndate)
  const [csec, setsec] = useState(sec)
  const [cmin, setmin] = useState(min)

      const clockj= ()=> 
      {

      
      
        hour = new Date().getHours();
        nhour=new Date().getHours();
        if (hour === 0) {
          nhour = 12;
        }if (hour > 12) {
          nhour = hour - 12;
        }
        setstate(nhour);
  
        
        // console.log(chour)
        setmin(min);
        ndate = new Date().toLocaleDateString();
        setdate(ndate);
        sec = new Date().getSeconds();
        setsec(sec);
      }
      setInterval(clockj, 1000);
    return(
        <>
        <div className="clock" >
          <div className="first-half">
            <div className="time">{chour} : {cmin} :</div>
            <div className="sec">{csec}</div>
          </div>
          <div className="date">{cdate}</div>

        </div>
          <Footer />
     </>

    )
}
